import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { ThemeId } from '../../styles/themes';

const ThemePickerStrip: React.FC = () => {
  const { themeId, previewTheme, availableThemes } = useTheme();

  return (
    <div className="theme-picker-strip">
      <span className="theme-picker-strip__label">Tema</span>
      <div className="theme-picker-strip__row">
        {availableThemes.map((t) => (
          <button
            key={t.id}
            type="button"
            className={`theme-picker-strip__dot${themeId === t.id ? ' theme-picker-strip__dot--active' : ''}`}
            onClick={() => previewTheme(t.id as ThemeId)}
            title={t.name}
            aria-label={t.name}
            aria-pressed={themeId === t.id}
          >
            <span style={{ background: t.preview[0] }} />
            <span style={{ background: t.preview[1] }} />
            <span style={{ background: t.preview[2] }} />
          </button>
        ))}
      </div>
    </div>
  );
};

export default ThemePickerStrip;
